import React, { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { toast } from 'react-hot-toast';
import { Plus, Trash2, Lock } from 'lucide-react';
import { rbacApi } from '../../services/rbacApi';

const RolesTab = () => {
  const [roles, setRoles] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: '', description: '' });

  const load = () => rbacApi.listRoles().then((r) => setRoles(r.data)).catch(() => toast.error('Failed to load roles'));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try { await rbacApi.createRole(form); toast.success('Role created'); setOpen(false); setForm({ name: '', description: '' }); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Save failed'); }
  };
  const remove = async (role) => {
    try { await rbacApi.deleteRole(role.role_id); toast.success('Deleted'); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Delete failed'); }
  };

  return (
    <div data-testid="roles-tab">
      <div className="flex justify-between items-center mb-4">
        <p className="text-sm text-gray-500">{roles.length} role(s)</p>
        <Button className="bg-orange-600 hover:bg-orange-700" onClick={() => setOpen(true)} data-testid="add-role-btn">
          <Plus className="w-4 h-4 mr-1" />New Role
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {roles.map((r) => (
          <div key={r.role_id} className="border rounded-lg p-4 hover:shadow-sm" data-testid={`role-card-${r.name}`}>
            <div className="flex justify-between items-start">
              <div>
                <div className="font-semibold flex items-center gap-1">
                  {r.is_system && <Lock className="w-3.5 h-3.5 text-gray-400" />}{r.name}
                </div>
                <p className="text-xs text-gray-500 mt-1">{r.description || '—'}</p>
              </div>
              {!r.is_system && (
                <Button size="sm" variant="ghost" className="text-red-600" onClick={() => remove(r)} data-testid={`delete-role-${r.name}`}>
                  <Trash2 className="w-4 h-4" />
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="role-dialog">
          <DialogHeader><DialogTitle>New Role</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Name</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="role-name" /></div>
            <div><Label>Description</Label><Input value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
            <Button className="bg-orange-600 hover:bg-orange-700" onClick={save} data-testid="save-role-btn">Save</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default RolesTab;
